import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';
import { CreateLotResponse } from '../components/bids-and-offers/lot-new/create-lot.model';

@Injectable({
  providedIn: 'root',
})
export class CreateLotService extends Mutation<CreateLotResponse> {
  document = gql`
    mutation CreateLot($input: CreateLotInput!) {
      createLot(createLotInput: $input) {
        _id
        destination
      }
    }
  `;
  // commodity
  // lot_type
  // grade
  // ship_begin
  // ship_end
  // volume_value
  // units
  // destination
  // delivery_type
  // currency
  // price_value
}
